import { HostTypes, Notifier } from '@picsart/design-system/components/Notifier';
import UserProvider from 'context/user/UserProvider';

import StylesProvider from 'providers/StylesProvider';
import INTLProvider from './IntlProvider';
import type { IProvider } from './types';
import RemoteSettingsProvider from './RemoteSettingsProvider';

function Providers({ children }: IProvider) {
  return (
    <StylesProvider>
      <UserProvider>
        <INTLProvider>
          <RemoteSettingsProvider>
            <Notifier zIndex={10} hostType={HostTypes.Editor}>
              {children}
            </Notifier>
          </RemoteSettingsProvider>
        </INTLProvider>
      </UserProvider>
    </StylesProvider>
  );
}

export default Providers;
